import { combineSlices, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import { PERSIST } from "redux-persist/es/constants";
import localStorage from "redux-persist/es/storage";

/** @public This is enhanced by async loaded slices */
export interface LazyLoadedSlices {}

export const rootReducer = combineSlices(
  {}
).withLazyLoadedSlices<LazyLoadedSlices>();

export function createAppStore() {
  return configureStore({
    reducer: persistReducer(
      { key: "root", storage: localStorage },
      rootReducer
    ),
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [PERSIST],
        },
      }),
  });
}

export function createPersistor(store: AppStore) {
  return persistStore(store);
}

export type AppStore = ReturnType<typeof createAppStore>;
export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = AppStore["dispatch"];
